<template>
    <div class="row">
        <div class="col" style=" display: flex; justify-content: center; flex-direction: column;">
            <h2 style="margin: 0;">Productos PPR {{ program.code }}</h2>
        </div>
        <div class="col-auto">
            <div class="form-inline">
                <label class="col-form-label mr-3">Año:</label>
                <select class="form-control" style="width: auto" @change="$event.target.value != '---' ? $router.push({ path: `/programa/${program.code}/${$event.target.value}` } ) : undefined">
                    <option selected>---</option>
                    <option v-for="(y, index) in availableYears" :key="index" :selected="y == year"> {{ y }} </option>
                </select>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "YearControl",
    props: {
        year: {
            type: Number,
            default: new Date().getFullYear()
        },
        program: {
            type: Object,
            default: () => {}
        },
        availableYears: {
            type: Array,
            default: () => []
        }
    }
}
</script>